import { saveAs } from 'file-saver'

export const downloadCSV = (records: string, orgName: string) => {
  const blob = new Blob([records], { type: 'text/plain;charset=utf-8' })
  saveAs(blob, `${orgName}_Gross_Eearnings_Records.csv`)
}
